<template>
  <div class="bind-roles">
    <NavBar
      class="msg-nav"
      :title="$t('bindRoles.绑定角色')"
      :goBack="goBack"
    />
    <Notice :top="noticeTop" />
    <div class="content">
      <van-form @submit="onSubmit">
        <van-field
          readonly
          clickable
          name="picker"
          :value="serverType.name"
          :label="$t('bindRoles.区服类型')"
          :placeholder="$t('bindRoles.区服类型')"
          :rules="[{ required: true, message: $t('bindRoles.请选择区服类型') }]"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :confirm-button-text="$t('app.确认')"
            :cancel-button-text="$t('app.取消')"
            :columns="currentServerTypeColumns"
            value-key="name"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          >
            <van-search
              slot="title"
              v-model="keyword"
              :placeholder="$t('bindRoles.请输入搜索关键词')"
            />
          </van-picker>
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="serverName.name"
          :label="$t('bindRoles.区服名称')"
          :placeholder="$t('bindRoles.区服名称')"
          :rules="[{ required: true, message: $t('bindRoles.请选择区服名称') }]"
          @click="showServerNamePicker = true"
        />
        <van-popup v-model="showServerNamePicker" position="bottom">
          <van-picker
            show-toolbar
            :confirm-button-text="$t('app.确认')"
            :cancel-button-text="$t('app.取消')"
            :columns="currentServerNameListColumns"
            value-key="name"
            @confirm="onServerConfirm"
            @cancel="showServerNamePicker = false"
          >
            <van-search
              slot="title"
              v-model="keyword"
              :placeholder="$t('bindRoles.请输入搜索关键词')"
            />
          </van-picker>
        </van-popup>
        <van-field
          v-model="roleName"
          name="input"
          :label="$t('bindRoles.角色名称')"
          :placeholder="$t('bindRoles.请输入角色昵称或角色数字ID')"
          :rules="[
            {
              required: true,
              message: $t('bindRoles.请输入角色昵称或角色数字ID'),
            },
          ]"
        />
        <van-field
          v-if="(vuexInitData && vuexInitData.need_check_mail) || is_auth"
          v-model="mail_code"
          :maxlength="6"
          center
          clearable
          :label="$t('bindRoles.验证码')"
          :placeholder="$t('bindRoles.请输入游戏内邮件验证码')"
        >
          <template #button>
            <van-button
              :loading="mailLoading"
              native-type="button"
              size="small"
              type="primary"
              @click="handleCode"
            >
              {{
                showTimer
                  ? `${$t("bindRoles.重新发送")}(${second}s)`
                  : $t("bindRoles.获取验证码")
              }}
            </van-button>
          </template>
        </van-field>
        <div class="footer">
          <van-button
            :loading="bindLoading"
            type="primary"
            native-type="submit"
            >{{ $t("bindRoles.绑定角色并进入") }}</van-button
          >
          <span
            v-if="
              vuexInitData &&
              vuexInitData.game_extra_config.guest_login_enabled &&
              (!roleList || roleList.length <= 0) &&
              userLoginType !== -1
            "
            class="tourist"
            @click="handleBindDefaultRole"
            >{{ $t("游客角色进入") }}</span
          >
        </div>
      </van-form>
      <div class="bind-roles-tip">若诉求账号无法登陆，请绑定其他角色</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Notice } from "@/components/Notice";
import {
  getServerTypeList,
  getServerList,
  bindRoles,
  apiSendGameMail,
  apiGuestRoleDefault,
} from "@/api/user";
import storage from "@/utils/storage";

export default {
  name: "BindRoles",
  components: { Notice },
  data() {
    return {
      // 绑定loading
      bindLoading: false,
      // 区服类型列表
      serverTypeList: [],
      // 区服名称列表
      serverNameList: [],
      // 角色名称或id
      roleName: "",
      // 选中的区服
      serverType: {},
      // 区服名称
      serverName: {},
      showPicker: false,
      // 发送邮件loading
      mailLoading: false,
      mail_code: "",
      showServerNamePicker: false,
      showTimer: false,
      second: 0,
      keyword: "",
      is_auth: 0,
      from: "",
      userLoginType: -1,
      isBindingDefault: false,
    };
  },
  computed: {
    ...mapGetters(["vuexInitData", "roleList"]),
    noticeTop() {
      let height =
        (document.getElementsByClassName("nav-bar")[0] &&
          document.getElementsByClassName("nav-bar")[0].offsetHeight) ||
        42;
      return height;
    },
    currentServerTypeColumns() {
      return this.serverTypeList.filter((item) => {
        const str = (item.name && item.name.toLowerCase()) || "";
        return str.includes(this.keyword.toLowerCase());
      });
    },
    currentServerNameListColumns() {
      return this.serverNameList.filter((item) => {
        const str = (item.name && item.name.toLowerCase()) || "";
        return str.includes(this.keyword.toLowerCase());
      });
    },
  },
  watch: {
    showPicker: {
      handler(val) {
        if (!val) {
          this.keyword = "";
        }
      },
    },
    showServerNamePicker: {
      handler(val) {
        if (!val) {
          this.keyword = "";
        }
      },
    },
  },
  created() {
    const { is_auth, from } = this.$route.query;
    if (is_auth) {
      this.is_auth = 1;
    }
    this.from = from;
  },
  mounted() {
    this.getServerType();

    const token = localStorage.getItem("token");
    if (token) {
      try {
        let strings = token.split(".");
        const loginUser = JSON.parse(
          decodeURIComponent(
            window.atob(strings[1].replace(/-/g, "+").replace(/_/g, "/")),
          ),
        );
        this.userLoginType =
          loginUser && loginUser.user && loginUser.user.login_type;
      } catch (error) {
        console.log("error", error);
      }
    }
  },
  methods: {
    handleCode() {
      if (!this.serverName.id) {
        this.$toast(this.$t("bindRoles.请选择区服"));
        return;
      }
      if (!this.roleName) {
        this.$toast(this.$t("bindRoles.请输入角色名称"));
        return;
      }
      if (this.showTimer) {
        return;
      }
      const params = {
        server_id: this.serverName.id,
        role: this.roleName,
      };
      this.mailLoading = true;
      apiSendGameMail(params)
        .then((res) => {
          if (res.code === 0) {
            this.showTimer = true;
            this.second = 60;
            this.timer = setInterval(() => {
              this.second = this.second - 1;
              if (this.second == 0) {
                this.clearTimer();
                return;
              }
            }, 1000);
          }
        })
        .finally(() => {
          this.mailLoading = false;
        });
    },
    goBack() {
      this.$router.back();
    },
    handleBindDefaultRole() {
      if (this.isBindingDefault) return;
      this.isBindingDefault = true;
      apiGuestRoleDefault()
        .then((res) => {
          if (res.code === 0) {
            this.$store.dispatch("getRoleList");
            if (this.from === "login") {
              this.$router.replace({ path: "/user-center" });
            } else {
              this.$router.back();
            }
          }
        })
        .finally(() => {
          this.isBindingDefault = false;
        });
    },
    getServerType() {
      getServerTypeList().then((res) => {
        if (res.code === 0) {
          this.serverTypeList = res.data || [];
        }
      });
    },
    // 确认选中区服类型
    onConfirm(value) {
      this.serverType = value || {};
      this.serverName = {};
      this.serverNameList = [];
      this.getServerList();
      this.showPicker = false;
    },
    // 获取区服名称列表
    getServerList() {
      if (!this.serverType.id) {
        return;
      }
      const params = {
        server_type: this.serverType.id,
      };
      getServerList(params).then((res) => {
        if (res.code === 0) {
          this.serverNameList = res.data || [];
        }
      });
    },
    // 选择区服名称
    onServerConfirm(value) {
      this.serverName = value || {};
      this.showServerNamePicker = false;
    },
    onSubmit() {
      const params = {
        server_id: this.serverName.id,
        role: this.roleName,
      };
      if (
        (this.vuexInitData && this.vuexInitData.need_check_mail) ||
        this.is_auth
      ) {
        if (!this.mail_code) {
          this.$toast(this.$t("bindRoles.请输入验证码"));
          return;
        }
        params.mail_code = this.mail_code.toString();
      }
      if (this.is_auth) {
        params.is_auth = 1;
      }
      this.bindLoading = true;
      bindRoles(params)
        .then((res) => {
          if (res.code === 0) {
            window.staticFn.customEvent("submit_report", {
              type: "bind_roles",
              game_id: storage.getGameId(),
              server_id: this.serverName.id,
              role: this.roleName,
            });
            this.$store.dispatch("getRoleList");
            if (this.from === "login") {
              this.$router.replace({ path: "/user-center" });
            } else {
              this.$router.back();
            }
          }
        })
        .finally(() => {
          this.bindLoading = false;
        });
    },
    // 清除定时器
    clearTimer() {
      this.showTimer = false;
      this.second = 0;
      clearInterval(this.timer);
    },
  },
};
</script>

<style lang="less" scoped>
.bind-roles {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f1f1f1;
  .nav {
    flex: 0 0 auto;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
  }
  .content {
    flex: 1;
    overflow: scroll;
    box-sizing: border-box;
    margin-top: 8px;
    .footer {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-top: 30px;
      button {
        width: 292px;
        height: 46px;
        font-size: 16px;
      }
      .tourist {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        color: #cda65e;
        font-size: 15px;
      }
    }
  }

  .bind-roles-tip {
    padding: 10px;
    color: red;
    font-size: 14px;
    text-align: center;
  }
  /deep/ .van-search {
    padding: 0;
  }
}
</style>
